<div id="content-display" class="content-smart-output" [ngClass]="{
    'content-padding-top': isPaddingTop,
    'content-size-normal': contentFontSize === 'normal',
    'content-size-small': contentFontSize === 'small',
    'inline-mode': displayMode === 'inline',
    'deleted': isDeleted
  }" [innerHTML]="processedBody" appMentionRoute></div>